import { useSession } from 'components/auth/useSession'
import { useSessionStorageState } from 'hooks/useStorage'
import { Dispatch, SetStateAction, useCallback } from 'react'

export interface JustificativaVerProntuario {
  id: ID
  basePath: string
  cidadaoId: ID
}

export function useJustificativaVerProntuarioId(
  basePath: string,
  cidadaoId: ID
): [ID | null, Dispatch<SetStateAction<ID>>, Dispatch<void>] {
  const { data } = useSession() ?? {}
  const acessoId = data?.acesso?.id

  const [justificativa, setStorageJustificativa, deleteStorageJustificativa] = useSessionStorageState<
    JustificativaVerProntuario
  >(`${acessoId}/justificativa-ver-prontuario`)

  const setJustificativaId = useCallback(
    (id: ID) => {
      if (!acessoId) return
      setStorageJustificativa({ id, basePath, cidadaoId })
    },
    [acessoId, basePath, cidadaoId, setStorageJustificativa]
  )

  const deleteJustificativa = useCallback(() => deleteStorageJustificativa(), [deleteStorageJustificativa])

  return [justificativa?.id, setJustificativaId, deleteJustificativa]
}
